<template>
    <div>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="132.7px"
	 height="177.3px" viewBox="0 0 132.7 177.3" style="enable-background:new 0 0 132.7 177.3;" xml:space="preserve">
<g id="boton3" @click="evaluar()">
	<g id="XMLID_2790_">
		<rect id="XMLID_11_" x="10.6" y="140.4" class="st3" width="111.5" height="29.5"/>
		<text transform="matrix(1 0 0 1 23.3071 152.436)"><tspan x="0" y="0" class="st2 st1 st4">Gas o Vapor  </tspan><tspan x="3.5" y="17" class="st2 st1 st4">Inflamable </tspan></text>
	</g>
	<linearGradient id="XMLID_3_" gradientUnits="userSpaceOnUse" x1="4.4214" y1="66.7808" x2="128.2456" y2="66.7808">
		<stop  offset="0" style="stop-color:#23CAD9"/>
		<stop  offset="0.9898" style="stop-color:#32ADF0"/>
	</linearGradient>
	<circle id="XMLID_2618_" class="st0" cx="66.3" cy="66.8" r="59.4"/>
	
		<image style="overflow:visible;" width="119" height="119" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAB3CAYAAAA5Od+KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ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" transform="matrix(1 0 0 1 6.8335 7.2808)">
	</image>
</g>
<g id="check3" :class="visto ?'mostrar':'esconder'">
	
		<image style="overflow:visible;" width="26" height="26" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
bWFnZVJlYWR5ccllPAAAAsVJREFUeNpiYKATYCRGkeTcIAUgFcDwn0EfSCsgSX0AmnARSG94nrzu
AtkWycwPMvj/n6EebAlh8ICRkaHxSeK6BSRZJLsgqB9IFZARSgeAFgY+il/3Aa9FCouDBIC+WA9k
OlAQJR+Aljk+iEUEJxO6CiZGhvnMTAwOQMxAARYAmrNfaWmwAMxcFmRLVJYFNxAZH8QAkCWgkHFE
CTq1lcEKwFR1HqqAJMDLys3Ax8bN8PTrK2zSibci1i5gQgqyfCaQl4EipOJO82yGje7dDFpCCtjk
61F8pLUm+D05vmk1yWEIkIekm8+/vzJ0XFzAsOHhfnRlhuA40lkX7ECOJf5yjnBLYEHICPUJGggA
WwSUMCDVEkdJM4YW42wUsaX3tjJsfrwfm0X2MItI8o06nwJDsyGqJZsfH2DouTofmyWIfIQvT4CC
p8kwB87nZ+dmmG3VCA4mGLj16QFD7/X5eM2B+Qgr8JZ2ZKjXy4YXIX035jPMMEO15Pn31wwZp+oZ
vv39itMceIYFKniALqHKqwC3BAR8ZBwY7CVMGXhZEJZ8+fOVofx8J0FLQEUSE9SiC+jp/+7XBwzb
nh1AzZhIloBAxYUuhjtAdUTktYPwfGS9J/g+Wl0DBmFy3gx5qokYTmy7NpVh2/P9xKYfQ0TJwMSw
EFskrn2ylaH9xlQUXauBYjtf7ieqgAWae+Coy9oLyEXQBGBm+4DN67uAhnbchFi24+UBhml355NS
RDVi1EeOh4IDGCElLlZgLWzGcOHjVYavwERADPjPwLBgv93aRKwVn/ORkH5G8mpWdEsuMPz/77jX
du0HnFW527EQcqtxGLgArKUdd1uv+UCwzeB+PCQAWB3PJ6OwnbDDYk0hSa0gz5MhAkDLQD6Lx5b0
0cACoC8at5uveUB2uw5cMpwOMQA3WBjRfPifAZSrL2wxXfMBn36AAAMAZz7LJ6pPpnwAAAAASUVO
RK5CYII=" transform="matrix(1 0 0 1 96.7456 10.9995)">
	</image>
</g>
</svg>
        <modal-app v-model="modala" :fullscreen="false" width="700px">
            <template slot="modaltittle">
</template>

<template slot="modalcontent">
    <v-layout row wrap justify-center align-center>
        <v-flex xs12 md6>
            <img class="img-fluid" src="@/assets/unidad1/pantalla-4-4.png" alt="">
        </v-flex>
        <v-flex xs12 md6>
            <h2>Gas o Vapor Inflamable</h2>
            <p>Gas, vapor o mezcla de ambos, que tiene la propiedad de generar un incendio y/o explosión, ya sea por autoignición o debido a una fuente de calor. Cada sustancia inflamable tiene definido un rango de inflamabilidad (explosividad) limitada por
                un porcentaje bajo (LEL) y un porcentaje alto (UEL) que lo caracteriza.</p>
        </v-flex>
    </v-layout>
</template>
        </modal-app>
    </div>
</template>

<script>
import nextConditions from "../../../js/mixins/nextConditions";
export default {
    mixins: [nextConditions],
    // props: {
    //     modala: {
    //         type: Boolean,
    //         default: false
    //     },
    // },
    data() {
        return {
            visto: false,
            modala: false
        }
    },
    methods: {
        evaluar() {
            this.modala = true;
            this.visto = true;
            this.$store.commit('vistosUnidad1Mod33', this.visto)
            if (this.$store.state.vistosUnidad1Mod31 && this.$store.state.vistosUnidad1Mod32 && this.$store.state.vistosUnidad1Mod33 && this.$store.state.vistosUnidad1Mod34) {
                this.$store.commit('vistosAllMod3', true)
            }
        }
    },
    mounted() {},
}
</script>


<style lang="scss" scoped>
svg {
    cursor: pointer;
}

.mostrar {
    display: block;
}

.esconder {
    display: none;
}
	.st0{fill:none;stroke:url(#XMLID_3_);stroke-width:5;stroke-miterlimit:10;}
	.st1{font-family:'FontBase-SemiBold';}
	.st2{fill:#2D2D2D;}
	.st3{fill:none;}
	.st4{font-size:17;}
</style>